import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

export const TotalClientSection = ({ totalClients, style, ...restProps }) => {
  return (
    <div
      style={{
        color: "black",
        fontWeight: "bold",
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        ...style,
      }}
      {...restProps}
    >
      <Icon name="clone outline" style={{ fontSize: "15pt" }} />
      <div style={{ marginLeft: "0.5em" }}>{`${totalClients} Client${
        totalClients > 1 ? "s" : ""
      }`}</div>
    </div>
  );
};

TotalClientSection.defaultProps = {
  style: {},
};
TotalClientSection.propTypes = {
  totalClients: PropTypes.number.isRequired,
  style: PropTypes.object,
};

export default TotalClientSection;
